export default __webpack_public_path__ + "static/media/Clear.8aa4751f.png";